"use client";

import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { axiosClient } from "@/lib/axiosClient";
import { cn } from "@/lib/utils";
import toast from "react-hot-toast";

interface ExportButtonProps {
    endpoint: string; // endpoint API ekspor
    filenamePrefix?: string; // nama file (default: export)
    className?: string; // override tampilan tombol (warna, tinggi, dll)
}

export default function ExportButton({
    endpoint,
    filenamePrefix = "export",
    className,
}: ExportButtonProps) {
    const [loading, setLoading] = useState(false);

    const handleExport = async (): Promise<void> => {
        try {
            setLoading(true);
            const res = await axiosClient.get(endpoint, { responseType: "blob" });

            const blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${filenamePrefix}_${new Date()
                .toISOString()
                .slice(0, 19)
                .replace(/[:T]/g, "-")}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);
            toast.success("Berhasil mengekspor data!");
        } catch (err) {
            console.error(err);
            toast.error("Gagal mengekspor data!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            onClick={handleExport}
            variant="outline"
            disabled={loading}
            className={cn(
                "flex items-center gap-2 bg-yellow-400 dark:hover:bg-slate-800 dark:hover:text-white border-gray-300 dark:border-gray-700 min-w-[150px]",
                className
            )}
        >
            {loading ? (
                <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    Mengekspor...
                </>
            ) : (
                <>
                    <Download className="w-4 h-4" />
                    Export Excel
                </>
            )}
        </Button>
    );
}
